exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/* CSS Document */\n/*メインコンテンツ系*/\n/*tooltip font*/\n/*ステータスカラー*/\n/* Sass Document */\n/* Filetype Web Font **********************************************************/\narticle .tableitem {\n  height: 100%; }\narticle .tableitem__tablearea {\n    width: calc(100% - 30px);\n    height: calc(100% - 68px);\n    position: relative;\n    margin-left: 30px;\n    overflow: hidden; }\narticle .tableitem__tablearea div.ag-spread {\n      height: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3020/wa3020.component.scss
// module id = ../../../../../src/app/pages/wa3Shipment/wa3020/wa3020.component.scss
// module chunks = main